import { NavigateFunction } from "react-router-dom";

export const handleGoBack = (navigate: NavigateFunction) => {
  if (window.history.state?.idx > 0) {
    navigate(-1);
  } else {
    navigate("/");
  }
};
